
import animate from './animate'

export default {
  beforeRouteEnter(to, from ,next){
    next(vm => {
      vm.scrollToTop()
    })
  },
  beforeRouteUpdate(to,form,next){
    this.scrollToTop()
    next()
  },
  methods: {
    scrollToTop() {
      //animate(document.documentElement, 'scrollTop', 0, 0)
      window.scroll({ top: 0 })
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/zcx/common/scrollMixin.js